import React, { useState, useEffect } from 'react';
import './HealthCheck.css';
import settings from '../config/settings';

const HealthCheck = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(settings.API_URL);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        const transformedServices = Object.entries(data).map(([key, value]) => {
          const [status, description] = value.split('::');
          return {
            name: key,
            status,
            description: description || '',
            expanded: false,
          };
        });
        setServices(transformedServices);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const toggleDescription = (index) => {
    setServices((prevServices) =>
      prevServices.map((service, i) =>
        i === index ? { ...service, expanded: !service.expanded } : service
      )
    );
  };

  if (loading) {
    return <p>Loading service statuses...</p>;
  }

  if (error) {
    return <p>Error loading data: {error}</p>;
  }

  return (
    <div className="health-check-container">
      <h2 className="health-check-title">Touch-E Health Check</h2>
      <p className="health-check-status">Service statuses:</p>
      <ul className="health-check-services">
        {services.map((service, index) => (
          <li
            key={index}
            className={`health-check-service ${service.expanded ? (service.status === 'UP' ? 'expanded-up' : 'expanded-down') : ''}`}
          >
            <div className="service-header" onClick={() => toggleDescription(index)}>
              <strong>{service.name}</strong>
              <span className={service.status === 'UP' ? 'service-up' : 'service-down'}>
                {service.status}
              </span>
            </div>
            {service.expanded && (
              <div className="service-description">{service.description}</div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HealthCheck;
